import { GetMessageV2, GetMessageV2Variables } from './__generated__/GetMessageV2'
import { useLazyQuery, useQuery } from '@apollo/react-hooks'

import { gql } from 'apollo-boost'

const QUERY = gql`
  query GetMessageV2($id: String!) {
    message: messageV2(id: $id) {
      ... on MessageV2 {
        id
        characters
        text
        tags
        cardSize
      }
      ... on MessageErrorV2 {
        type
        error
      }
    }
  }
`

export const useGetMessage = (id: string, { skip }: { skip?: boolean }) => {
  return useQuery<GetMessageV2, GetMessageV2Variables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables: { id },
    skip
  })
}

export const useGetMessageLazy = () => {
  return useLazyQuery<GetMessageV2, GetMessageV2Variables>(QUERY)
}
